<template>
  <jee-aside-layout class="config-site-permission-container">
    <el-button
      slot="asideHeader"
      size="medium"
      type='primary'
      @click="handleHeaderRecycle()"
      :disabled="!_checkPermission('/admin/sites/recycle', 'GET')"
    >
      <jee-icon iconClass="huishouzhan"></jee-icon>站点回收站
    </el-button>
    <drag-tree
      slot="asideMain"
      v-if="siteId"
      v-bind="siteTree"
      @handleClick="handleClick"
    ></drag-tree>
    <section slot="main">
      <base-header v-bind="headers"/>
      <el-tabs v-model="currentTab">
        <template v-for="(tab, index) in tabs">
          <el-tab-pane :label="tab.label" :name="tab.name" :key="index">
            <component :is="tab.component" name="siteId" :value="siteId" :key="index"/>
          </el-tab-pane>
        </template>
      </el-tabs>
    </section>
    <table-dialog
      ref="recycleBin"
      v-bind="tablelist"
      @handleSelectionChange="handleTableDialogSelectionChange"
      @handleBtnDelete='recycleBinDelete'
      @handleBtnRestore='recycleBinRestore'
    ></table-dialog>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </jee-aside-layout>
</template>

<script>
import sites from './../sites'
import baseHeader from '@/components/mixins/baseHeader'
import OrgPermission from './OrgPermission'
import UserPermission from './UserPermission'

export default {
  name: 'configSitePermissionSite',
  mixins: [baseHeader, sites],
  components: {
    OrgPermission,
    UserPermission
  },
  data () {
    return {
      headers: {
        title: '操作说明',
        content: '这里是站点权限分配'
      },
      siteId: '',
      siteTree: {
        loading: false,
        data: [],
        currentNodeKey: '',
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      },
      currentTab: 'org',
      tabs: [
        {
          label: '组织及角色',
          name: 'org',
          component: 'OrgPermission'
        },
        {
          label: '用户',
          name: 'user',
          component: 'UserPermission'
        }
      ]
    }
  },
  inject: ['removeTab'],
  methods: {
    // 点击站点
    handleClick (data) {
      this.siteId = data.id
      this.siteTree.currentNodeKey = data.id
    },
    // 获取树结构
    fetchSiteseList () {
      this.siteTree.loading = true
      this.$request.fetchSiteseList().then(res => {
        if (res.code === 200) {
          this.siteTree.data = res.data
        }
        this.siteTree.loading = false
      }).catch(() => {
        this.siteTree.loading = false
      })
    }
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.siteId = id
      this.siteTree.currentNodeKey = Number(id)
    }
  },
  mounted () {
    this.fetchSiteseList()
  }
}
</script>

<style lang="scss">

</style>
